import React from 'react';

import { Combobox, ComboboxInputProps } from '@lumapps/lumx/react';
import { useTranslate } from '@lumapps/translations';
import { GLOBAL } from '@lumapps/translations/keys';

import { SEARCHBOX_FOOTER_ID } from '../../constant';
import { useHasShortcuts } from '../../hooks/useHasShortcuts';

interface SearchboxInputProps extends ComboboxInputProps {
    /** Callback executed when the listbox opens */
    onOpen?: () => void;
}

/**
 * The input element of the search box.
 */
export const SearchboxInput = ({ onOpen, ...props }: SearchboxInputProps) => {
    const isOpen = Combobox.useComboboxEvent('open', false);
    const hasShortcuts = useHasShortcuts();
    const { translateKey } = useTranslate();

    React.useEffect(() => {
        if (isOpen) {
            onOpen?.();
        }
    }, [isOpen, onOpen]);

    return (
        <Combobox.Input
            filter="manual"
            openOnFocus
            {...props}
            aria-describedby={isOpen && hasShortcuts && SEARCHBOX_FOOTER_ID}
            clearButtonProps={{ label: translateKey(GLOBAL.CLEAR_SEARCH) }}
        />
    );
};
